








import Vue from 'vue';

export default Vue.extend({
  name: 'Pagenation',
  props: {
    currentPage: Number,
    maxPage: Number,
  },
  data() {
    return {
    };
  },
  methods: {
    onPrev() {
      this.$emit('change', Math.max(this.currentPage - 1, 1));
    },
    onNext() {
      this.$emit('change', Math.min(this.currentPage + 1, this.maxPage));
    },
  },
})
